import { connect, MapDispatchToProps } from 'react-redux';
import { repositionBookmark } from '@wix/da-submit-shared/pkg/redux/actions';
import { Props } from './BookmarksListMobile';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'updateFolderOrder'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  updateFolderOrder: (folder, position) => dispatch(repositionBookmark(folder, position)),
});

export default connect(null, mapDispatchToProps);
